// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { ISelectedConfiguration } from '@app/core/models/core-models';
import { defaultImage } from '@app/core/helpers/constants';

@Component({
  selector: 'app-configuration-created-header',
  templateUrl: './configuration-created-header.component.html',
  styleUrls: ['./configuration-created-header.component.scss']
})
export class ConfigurationCreatedHeaderComponent implements OnInit {
  @Input() selectedConfigData?: ISelectedConfiguration;
  @Input() currentCampaignName: string = '';
  @Input() step: number = 1;
  @Input() component?: string;

  public readonly defaultImage = defaultImage;
  public selectedBannerSize: string = '';

  get isBannerComponent(): boolean {
    return this.component === 'banners';
  }

  ngOnInit(): void {
    this.selectedBannerSize = `${this.selectedConfigData?.width || 0}x${this.selectedConfigData?.height || 0}`;
  }
}
